module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-container', [_c('v-row', {
    staticClass: "mt-5 pt-5 mb-5"
  }, [_c('v-col', {
    attrs: {
      "md3": "md3"
    }
  }), _vm._v(" "), _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "md6": "md6",
      "xs12": "xs12"
    }
  }, [_c('div', {
    staticClass: "display-2"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('blockquote', {
    staticStyle: {
      "border-left": "0px",
      "padding-left": "0rem"
    }
  }, [_c('v-icon', {
    staticClass: "display-1 primary--text pr-2",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_vm._v("people")]), _vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    ")], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.error.timeout,
      "top": true
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.error.show = $$v
      },
      expression: "error.show"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.error.message) + "\n        "), _c('v-btn', {
    staticClass: "blue--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.error.show = false
      }
    }
  }, [_vm._v("Chiudi")])], 1), _vm._v(" "), _c('v-stepper', {
    staticClass: "text-xs-left",
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.stage),
      callback: function($$v) {
        _vm.stage = $$v
      },
      expression: "stage"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.stage > 1
    }
  }, [_vm._v("\n      I tuoi dati anagrafici\n    ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_vm._l((_vm.member.personal), function(m) {
    return _c('v-text-field', {
      key: m.label,
      attrs: {
        "label": m.label,
        "type": m.type
      },
      model: {
        value: (m.data),
        callback: function($$v) {
          m.data = $$v
        },
        expression: "m.data"
      }
    })
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.nextStep('personal')
      }
    }
  }, [_vm._v(_vm._s(_vm.next))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage--
      }
    }
  }, [_vm._v(_vm._s(_vm.back))])], 2), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.stage > 2
    }
  }, [_vm._v("\n      La tua residenza\n    ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_vm._l((_vm.member.address), function(m) {
    return _c('v-text-field', {
      key: m.label,
      attrs: {
        "label": m.label,
        "type": m.type
      },
      model: {
        value: (m.data),
        callback: function($$v) {
          m.data = $$v
        },
        expression: "m.data"
      }
    })
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.nextStep('address')
      }
    }
  }, [_vm._v(_vm._s(_vm.next))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage--
      }
    }
  }, [_vm._v(_vm._s(_vm.back))])], 2), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v("\n      Adesione allo statuto\n    ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('p', {
    staticClass: "text-xs-left",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("\n        Dichiaro di aver preso visione dello Statuto dell'Associazione e di accettarlo e rispettarlo in ogni suo punto.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://drive.google.com/uc?export=download&id=0ByYab0ydL41gbnQ1NWQ0ZmhnaDQ"
    }
  }, [_vm._v("Leggi lo statuto di 5pani2pesci")])]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "primary": "",
      "label": "Accetto"
    },
    model: {
      value: (_vm.member.accept.statute),
      callback: function($$v) {
        _vm.member.accept.statute = $$v
      },
      expression: "member.accept.statute"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("\n        Acconsento al trattamento dei dati personali ai sensi dell'art. 13 D.lgs. n. 196/2003")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "primary": "",
      "label": "Accetto"
    },
    model: {
      value: (_vm.member.accept.ordinary),
      callback: function($$v) {
        _vm.member.accept.ordinary = $$v
      },
      expression: "member.accept.ordinary"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("\n        Autorizzo la fotografia e la ripresa della mia immagine ed il suo utilizzo per i fini istituzionali di 5pani2pesci")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "primary": "",
      "label": "Accetto"
    },
    model: {
      value: (_vm.member.accept.images),
      callback: function($$v) {
        _vm.member.accept.images = $$v
      },
      expression: "member.accept.images"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": "",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.submitMembership()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.submit) + "\n      ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage--
      }
    }
  }, [_vm._v(_vm._s(_vm.back))])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "primary mt-0",
    attrs: {
      "height": "200px"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fcad526"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Membership.vue
// module id = 120
// module chunks = 1